import React from "react";
import styles from "./switch.module.css";
import { HiCheck } from "react-icons/hi";

function Switch({ value, values, setValues, setValue, notSetState, notSetStateValue, setValuesOnDisabled, valuesOnDisabled }) {
    
    function handleValueChange(){
        if (notSetState){
            let tempValues = [...values];
            for (const val of tempValues){
                if (val === notSetStateValue){
                    val.value = !val.value;
                    return setValues(tempValues);
                }
            }
        }
        else {
            if (valuesOnDisabled && setValuesOnDisabled && value){
                let tempValues = [...valuesOnDisabled];
                for(const value of tempValues){
                    value.value = false;
                }
                setValuesOnDisabled(tempValues);
            }
            return setValue(!value);
        }
    }

    return (
        <div className={styles.switchContainer} onClick={() => handleValueChange()}>
            {
                value ?
                    <HiCheck color="var(--text)" />
                :""
            }
        </div>
    );
}

export default Switch;